import { Grid } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import ActivityType from './ActivityType'
import EmploymentType from './EmploymentType'
import FlatRateTax from './FlatRateTax'
import PersonalKeyGroup from './PersonalKeyGroup'

interface Props {
  contractVersion: ContractVersionPageContractVersionFragment
}

const Germany = ({ contractVersion }: Props) => {
  const canEdit = contractVersion._policies?.edit?.can ?? false
  const activityTypeId = contractVersion.deActivityType
  const employmentTypeId = contractVersion.deEmploymentType
  const flatRateTaxId = contractVersion.deFlatRateTax
  const personalKeyGroupId = contractVersion.dePersonalKeyGroupId
  const showActivityType = !!activityTypeId || canEdit
  const showEmploymentType = !!employmentTypeId || canEdit
  const showFlatRateTax = !!flatRateTaxId || canEdit
  const showPersonalKeyGroup = !!personalKeyGroupId || canEdit

  return (
    <Grid variant="fixed">
      {showActivityType && <ActivityType activityTypeId={activityTypeId} />}
      {showEmploymentType && <EmploymentType employmentTypeId={employmentTypeId} />}
      {showFlatRateTax && <FlatRateTax flatRateTaxId={flatRateTaxId} />}
      {showPersonalKeyGroup && <PersonalKeyGroup personalKeyGroupId={personalKeyGroupId} />}
    </Grid>
  )
}

export default Germany
